import loggingService from "services/loggingService";

export const createSSOLoggingRecord = (data) => async _ => {
    await loggingService.createLoggingRecord('sso', data);
};
